import WorkerService from "../../WorkerService"
import WorkerOrderMapEntity from "@/NewModel/Worker/Order/Entity/WorkerOrderMapEntity"

const
    FETCHING_RECORDS = "FETCHING_RECORDS",
    FETCHING_RECORDS_SUCCESS = "FETCHING_RECORDS_SUCCESS",
    FETCHING_RECORDS_ERROR = "FETCHING_RECORDS_ERROR",
    CLEAR_RECORDS = "CLEAR_RECORDS"

const initialState = {
    isLoading: false,
    records: [],
}

export const state = {...initialState}

export const actions = {


    async getMapOfOrders({commit}, date) {
        try {
            commit(FETCHING_RECORDS)
            let response = await WorkerService.getMapOfOrders(date)
            commit(FETCHING_RECORDS_SUCCESS, response.data)
            return state.records
        } catch (error) {
            commit(FETCHING_RECORDS_ERROR, error)
            return Promise.reject(error)
        }
    },

    async clearRecords({commit}) {
        commit(CLEAR_RECORDS)
    }

}

export const mutations = {

    [FETCHING_RECORDS](state) {
        state.isLoading = true
        state.records = []
    },
    [FETCHING_RECORDS_SUCCESS](state, records) {
        state.isLoading = false
        state.records = records.map((order) => new WorkerOrderMapEntity(order))
    },
    [FETCHING_RECORDS_ERROR](state) {
        state.isLoading = false
        state.records = []
    },

    [CLEAR_RECORDS](state) {
        state.isLoading = false
        state.records = []
    }

}

export const getters = {

    isLoading(state) {
        return state.isLoading
    },
    hasRecords(state) {
        return state.records.length > 0
    },
    getRecords(state) {
        return state.records
    },

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
